"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ProductCompare;
var React = require("react");
var Portal_1 = require("../Portal");
var Actions_1 = require("@src/compare/Actions");
function ProductCompare(props) {
    if (!props.favourites.length) {
        return null;
    }
    var getImageFilename = function (product) {
    };
    var toggleFavAction = props.toggleFavAction, resetAction = props.resetAction, favourites = props.favourites, state = props.state;
    var listItems = favourites.map(function (product) {
        return (React.createElement("div", { key: product.ARIDENT, className: "image" },
            React.createElement("input", { type: "hidden", value: product.GTIN, name: "gtins" }),
            React.createElement("img", { src: product.ImageFileName, alt: product.Name, title: product.Name }),
            React.createElement("a", { onClick: function (e) {
                    return toggleFavAction(e, product, state.state, state.dispatch);
                }, className: "link", href: "#" }, "Fjern")));
    });
    return (React.createElement(Portal_1.default, { id: "divCompareProductPreview" },
        React.createElement("div", { className: "food-compare g-clearfix" },
            "Du kan sammenligne inntil 3 matvarer",
            React.createElement("a", { className: "link", "data-ajax": "true", onClick: function () { return resetAction(state.dispatch); }, "data-ajax-method": "get", href: "/comparepreview/reset" }, "Fjern alle"),
            React.createElement("form", { method: "post", action: location.origin + '/compare' },
                React.createElement("div", { className: "food-items" },
                    listItems,
                    React.createElement("div", { className: "image" },
                        React.createElement("button", { type: "submit", disabled: favourites.length <= 1, className: "btn btn-standard food-compare__compared", onClick: function () { return (0, Actions_1.saveSession)([]); } }, "Sammenlign")))))));
}
